import React, {useState, useEffect, Fragment} from 'react'
import {useDispatch} from "react-redux"
import PropTypes from "prop-types"

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'

// Material-UI Icon

// Custom Component
import {Alert} from '../Alert/Alert'
import ConfirmDialog from '../Dialog/ConfirmDialog'
import FullScreenDialog from "../Dialog/FullScreenDialog"
import useLoading from "../Loading/useLoading"
import UserGroupList from './UserGroupList'
import UserGroupForm from './UserGroupForm'

// Custom Style
import {userGroupStyle} from '../../styles/jss/components/userGroup/userGroupStyle'

// Global Function

// Fetch Data
import {getUser, getUserGroupType, createUserGroup, modifyUserGroup, deleteUserGroup} from '../../dataSource/userGroup'


const TabPanel = props => {
	const {children, value, index, ...other} = props

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={1}>
					<div>{children}</div>
				</Box>
			)}
		</div>
	)
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
}

const a11yProps = index => {
	return {
		id: `submission-tab-${index}`,
		'aria-controls': `submission-tabpanel-${index}`,
	}
}


const useStyles = makeStyles(theme => userGroupStyle(theme))

const UserGroup = props => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const {} = props

	const [getUserListLoading, getUserListShowLoading, getUserListHiddenLoading] = useLoading()

	const [tabValue, setTabValue] = useState(0)
	const [groupSeq, setGroupSeq] = useState(null)
	const [userList, setUserList] = useState(null)
	const [userGroupType, setUserGroupType] = useState(null)
	const [userGroupValue, setUserGroupValue] = useState(null)
	const [validationErrors, setValidationErrors] = useState({})
	const [formType, setFormType] = useState("")   // CREATE, MODIFY
	const [userGroupListRefresh, setUserGroupListRefresh] = useState(0)
	const [userGroupFormDialogOpen, setUserGroupFormDialogOpen] = useState(false)

	const [alertOpen, setAlertOpen] = useState(false)
	const [alertData, setAlertData] = useState({
		type: "",
		title: "",
		content: ""
	})

	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
	const [confirmDialogData, setConfirmDialogData] = useState({
		dialogTitle: "",
		dialogContent: "",
		confirmAction: "",
		cancelAction: ""
	})

	const userGroupValueTemplate = {
		group_name: "",
		group_description: "",
		group_members: [],
		type_seq: 0
	}


	const handleTabChange = (event, newValue) => {
		setTabValue(newValue)
	}


	// Build Alert
	const buildAlert = (data) => {
		setAlertData({
			type: data.type,
			title: data.title,
			content: data.content
		})
		setAlertOpen(true)
	}


	// Confirm dialog
	const confirmDialogHandleOpen = (data) => {
		setConfirmDialogData({
			dialogTitle: data.dialogTitle,
			dialogContent: data.dialogContent,
			confirmAction: data.confirmAction,
			cancelAction: data.cancelAction
		})

		setConfirmDialogOpen(true)
	}

	const confirmDialogHandleClose = () => {
		setConfirmDialogOpen(false)
	}


	// Dialog open and close
	const userGroupFormDialogHandleOpen = (typeSeq, userGroupSelected) => () => {
		if (userGroupSelected !== null) {
			setFormType("MODIFY")
			setGroupSeq(userGroupSelected.group_seq)
			setUserGroupValue(userGroupSelected)
		}
		else {
			let tempUserGroupValue = {...userGroupValueTemplate}
			tempUserGroupValue.type_seq = typeSeq

			setFormType("CREATE")
			setUserGroupValue(tempUserGroupValue)
		}

		setUserGroupFormDialogOpen(true)
	}

	const userGroupFormDialogHandleClose = () => {
		setGroupSeq(null)
		setUserGroupValue(null)
		setUserGroupFormDialogOpen(false)
	}

	
	const createGroupActionConfirmOpen = () => {
		if (validate()) {
			confirmDialogHandleOpen({
				dialogTitle: "Create User Group",
				dialogContent: "Are you sure to create the user group.",
				confirmAction: createGroupAction,
				cancelAction: createGroupActionComfirmClose
			})
		}
	}

	const createGroupActionComfirmClose = () => {
		confirmDialogHandleClose()
	}


	const modifyGroupActionConfirmOpen = () => {
		if (validate()) {
			confirmDialogHandleOpen({
				dialogTitle: "Modify User Group",
				dialogContent: "Are you sure to save change.",
				confirmAction: modifyGroupAction,
				cancelAction: modifyGroupActionConfirmClose
			})
		}
	}

	const modifyGroupActionConfirmClose = () => {
		confirmDialogHandleClose()
	}


	const deleteGroupActionConfirmOpen = groupSeq => () => {
		confirmDialogHandleOpen({
			dialogTitle: "Delete User Group",
			dialogContent: "Are you sure to delete the User Group.",
			confirmAction: () => deleteGroupAction(groupSeq),
			cancelAction: deleteGroupActionConfirmClose
		})

	}

	const deleteGroupActionConfirmClose = () => {
		confirmDialogHandleClose()
	}


	// Main Action
	const createGroupAction = () => {

		createUserGroup(userGroupValue).then(res => {
			createGroupActionComfirmClose()
			userGroupFormDialogHandleClose()

			setUserGroupListRefresh(userGroupListRefresh + 1)

			console.log("*****************************************************************************")
			console.log("System Module: User Group")
			console.log("Message: User Group Create successful.")
			console.log(res)
			console.log("*****************************************************************************")

			buildAlert({
				// Alert Type: success, info, warning, error
				type: "success",
				title: "Success Alert",
				content: "The User Group have been create"
			})
		})
	}


	const modifyGroupAction = () => {
		modifyGroupActionConfirmClose()

		modifyUserGroup(groupSeq, userGroupValue).then(res => {
			userGroupFormDialogHandleClose()
			setUserGroupListRefresh(userGroupListRefresh + 1)

			console.log("*****************************************************************************")
			console.log("System Module: User Group")
			console.log("Message: User Group Modify successful.")
			console.log(res)
			console.log("*****************************************************************************")

			buildAlert({
				// Alert Type: success, info, warning, error
				type: "success",
				title: "Success Alert",
				content: "The user group has been saved"
			})
		})
		.catch(error => {
			buildAlert({
				// Alert Type: success, info, warning, error
				type: "error",
				title: "Error Alert",
				content: error
			})
		})
	}


	const deleteGroupAction = groupSeq => {
		deleteGroupActionConfirmClose()
		
		deleteUserGroup(groupSeq).then(res => {
			setUserGroupListRefresh(userGroupListRefresh + 1)

			console.log("*****************************************************************************")
			console.log("System Module: User Group")
			console.log("Message: User Group Delete successful.")
			console.log(res)
			console.log("*****************************************************************************")

			buildAlert({
				// Alert Type: success, info, warning, error
				type: "success",
				title: "Success Alert",
				content: "The User Group have been deleted"
			})
		})
		.catch(error => {
			buildAlert({
				// Alert Type: success, info, warning, error
				type: "error",
				title: "Error Alert",
				content: error
			})
		})
	}


	// Dialog Button
	const userGroupCreateDialogBtn = [
		{
			buttonName: "Create",
			buttonFunction: createGroupActionConfirmOpen,
			chooseFile: false
		},
	]

	const userGroupModifyDialogBtn = [
		{
			buttonName: "Save",
			buttonFunction: modifyGroupActionConfirmOpen,
			chooseFile: false
		},
	]


	// Input Validation
	const validate = (fieldValues = userGroupValue) => {
		let temp = {...validationErrors}
		  
		if ("group_name" in fieldValues) {
			temp.group_name = fieldValues.group_name ? "" : "This field is required"
		}

		if ("group_description" in fieldValues) {
			temp.group_description = fieldValues.group_description ? "" : "This field is required"
		}

		setValidationErrors({...temp})

		if (fieldValues == userGroupValue) {
			return Object.values(temp).every(x => x == "")
		}
	}


	useEffect(() => {
		getUserGroupType().then(res => {
			setUserGroupType(res.data)
		})

		getUserListShowLoading()		
		getUser("ALL").then(res => {
			setUserList(res.data)
			getUserListHiddenLoading()
		})
	}, [])



	return (
		// console.log("Type Seqance | Variable: tabValue (UserGroup.js)"),
		// console.log(tabValue),

		// console.log("User List | Variable: userList (UserGroup.js)"),
		// console.log(userList),

		// console.log("Group Sequence | Variable: groupSeq (UserGroup.js)"),
		// console.log(groupSeq),

		// console.log("User Group Type | Variable: userGroupType (UserGroup.js)"),
		// console.log(userGroupType),

		// console.log("User Group Value | Variable: userGroupValue (UserGroup.js)"),
		// console.log(userGroupValue),

		// console.log("Validation Errors | Variable: validationErrors (UserGroup.js)"),
		// console.log(validationErrors),

		// console.log("---------------------------------------------------------------------------------"),


		<Fragment>
			<Alert
				open={alertOpen}
				alertType={alertData.type}
				alertTitle={alertData.title}
				alertContent={alertData.content}
				handleClose={() => setAlertOpen(false)}
			/>

			<ConfirmDialog
				open={confirmDialogOpen}
				dialogTitle={confirmDialogData.dialogTitle}
				dialogContent={confirmDialogData.dialogContent}
				confirmAction={confirmDialogData.confirmAction}
				cancelAction={confirmDialogData.cancelAction}
			/>

			<FullScreenDialog
				open={userGroupFormDialogOpen}
				dialogTitle={formType === "CREATE" ? "Create User Group" : formType === "MODIFY" ? "Modify User Group" : ""}
				formContent={
					<UserGroupForm
						userList={userList}
						userGroupValue={userGroupValue}
						setUserGroupValue={setUserGroupValue}
						validate={validate}
						validationErrors={validationErrors}
					/>
				}
				button={formType === "CREATE" ? userGroupCreateDialogBtn : formType === "MODIFY" ? userGroupModifyDialogBtn : []}
				handleClose={userGroupFormDialogHandleClose}
			/>
			
			
			<AppBar position="static" color="default" >
				<Tabs value={tabValue} onChange={handleTabChange} aria-label="user group tabs " textColor="primary" indicatorColor="primary">
					{
						userGroupType !== null ?
							userGroupType.map(res => {
								return (
									<Tab key={res.type_seq} label={res.type_name} {...a11yProps(res.type_seq)} />
								)
							})
						: ""
					}
				</Tabs>
			</AppBar>
			{
				userGroupType !== null ?
					userGroupType.map((res, index) => {
						return (
							<TabPanel key={res.type_seq} value={tabValue} index={index}>
								{
									userList !== null ?
										<UserGroupList
											key={index}
											typeSeq={res.type_seq}
											userGroupFormDialogHandleOpen={userGroupFormDialogHandleOpen}
											deleteGroupActionConfirmOpen={deleteGroupActionConfirmOpen}
											userGroupListRefresh={userGroupListRefresh}

											getUserListLoading={getUserListLoading}
										/>
									: ""
								}
							</TabPanel>
						)
					})
				: ""
			}

		</Fragment>
	)
}


export default UserGroup